import { createSlice } from "@reduxjs/toolkit";
import { handleErrorStopLoading, handleLoading } from "redux/redux-util";
import { DefaultPaginable } from "const";

const initialState = {
  loading: false,
  histories: [],
  year: null,
  paginable: { ...DefaultPaginable },
  endPaging: false,
  total: 0,
};

const slice = createSlice({
  initialState,
  name: "withholdTaxHistories",
  reducers: {
    getWithholdingTaxHistory: handleLoading,
    getWithholdingTaxHistorySuccess: (state, action) => {
      state.loading = false;
      if (state.year !== action.payload.year) {
        state.year = action.payload.year;
        state.histories = [...action.payload.histories];
      } else {
        state.histories = [...state.histories, ...action.payload.histories].filter(
          (item, index, self) => index === self.findIndex((o) => o.eWithholdingTransNo === item.eWithholdingTransNo)
        );
      }
      state.total = action.payload.total;
      state.paginable = action.payload.paginable;
      if (state.histories.length >= action.payload.total) {
        state.endPaging = true;
      }
    },
    getWithholdingTaxHistoryFailure: handleErrorStopLoading,
    reset: (state, action) => {
      return initialState;
    },
  },
});

export const { getWithholdingTaxHistory, getWithholdingTaxHistorySuccess, getWithholdingTaxHistoryFailure, reset } =
  slice.actions;

export default slice.reducer;
